import {
  SET_FORM_DATA
} from './actionTypes'

export reducer = (state, { type, payload }) ->
  try
    switch (type)
      when SET_FORM_DATA
        { state..., formData: payload.data }
      else
        throw new Error("SequencedFormData reducer recieved an invalid action type (#{ type }).")
  catch e
    console.error(e)


